<script lang="ts">
	// "Ask Bosla" in the hero, as "Home Visibility" draws it: pick a question,
	// the needle seeks while it runs and settles on the answer. Not built yet;
	// shown without «قريبًا» at the owner's decision (2026-10-03). Its numbers
	// are examples and say so.

	import Card from '../components/Card.svelte';
	import Loading from '../components/Loading.svelte';
	import Meter from '../components/Meter.svelte';
	import NavItem from '../components/NavItem.svelte';
	import { ask } from './copy';
	import Rich from './Rich.svelte';

	let picked = $state(0);
	let seeking = $state(false);
	let timer: ReturnType<typeof setTimeout> | undefined;

	const question = $derived(ask.questions[picked] ?? ask.questions[0]);

	function pick(index: number) {
		clearTimeout(timer);
		picked = index;
		seeking = true;
		timer = setTimeout(() => (seeking = false), 1100);
	}

	$effect(() => () => clearTimeout(timer));
</script>

<div id="ask">
	<Card title={ask.title} note={ask.note} testId="site-ask">
		<div class="body">
			<p class="caption">{ask.example}</p>
			<div class="questions">
				{#each ask.questions as item, index (item.text)}
					<NavItem
						testId="site-ask-{index}"
						label={item.text}
						active={index === picked}
						ground="card"
						onPress={() => pick(index)}
					/>
				{/each}
			</div>
			<div class="answer">
				<div class="status">
					<Loading
						size="sm"
						state={seeking ? 'seeking' : 'found'}
						label={ask.seeking}
						caption={seeking ? ask.searchingIn + question.scan : ask.found}
					/>
				</div>
				{#if !seeking}
					<p class="lead"><Rich line={question.lead} /></p>
					<div class="bars">
						{#each question.bars as bar (bar.label)}
							<div class="bar">
								<span class="label">{bar.label}</span>
								<Meter value={bar.value} tone={bar.tone} label={bar.label} />
								<span class="figure value">{bar.display}</span>
							</div>
						{/each}
					</div>
					<p class="source">{question.source}</p>
				{/if}
			</div>
		</div>
	</Card>
</div>

<style>
	.body {
		display: grid;
		grid-template-columns: minmax(0, 1fr);
		gap: var(--space-7);
		padding: var(--space-7) var(--space-9) var(--space-9);
	}

	.questions {
		display: flex;
		flex-direction: column;
		gap: 2px;
		padding: var(--space-2);
		background: var(--surface-card);
		border: var(--border-width) solid var(--border-inset);
		border-radius: var(--radius-card);
	}

	.answer {
		min-block-size: 230px;
		display: flex;
		flex-direction: column;
		gap: var(--space-6);
	}

	.status {
		display: flex;
		align-items: center;
		color: var(--text-strong);
	}

	.lead {
		margin: 0;
		font-size: var(--text-sm);
		line-height: var(--leading-body);
		color: var(--text-body);
	}

	.bars {
		display: flex;
		flex-direction: column;
		gap: var(--space-4);
	}

	.bar {
		display: grid;
		grid-template-columns: minmax(0, 7.5rem) minmax(0, 1fr) auto;
		gap: var(--space-5);
		align-items: center;
	}

	.label {
		font-size: var(--text-2xs);
		font-weight: var(--weight-semibold);
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
	}

	.value {
		font-size: var(--text-2xs);
		font-weight: var(--weight-semibold);
	}

	.source {
		margin: 0;
		padding-block-start: var(--space-5);
		border-block-start: var(--border-width) solid var(--border-inset);
		font-family: var(--font-mono);
		font-size: var(--text-micro);
		color: var(--text-muted);
	}
</style>
